import { render, staticRenderFns } from "./eventDetailsDialog.vue?vue&type=template&id=568cbbfe"
import script from "./eventDetailsDialog.vue?vue&type=script&lang=js"
export * from "./eventDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./eventDetailsDialog.vue?vue&type=style&index=0&id=568cbbfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports